module.exports = __webpack_public_path__ + "static/SweetSans-Regular-cadcb62b7db50c46a6c3702786468dca.woff";